export default __webpack_public_path__ + "static/media/Elite.d788029f.png";